import script from "./DataSourceProLinks.vue?vue&type=script&setup=true&lang=js"
export * from "./DataSourceProLinks.vue?vue&type=script&setup=true&lang=js"

import "./DataSourceProLinks.vue?vue&type=style&index=0&id=6efe4eb8&lang=css"

const __exports__ = script;

export default __exports__